import Model from '../Model'
import Product from './Product'

export default class Category extends Model {
  resource () {
    return 'categories'
  }

  primaryKey () {
    return 'slug'
  }

  products () {
    return this.hasMany(Product)
  }
}
